import { MatxLoadable } from "matx";
import { authRoles } from "../../auth/authRoles";

const NewApplication = MatxLoadable({
    loader: () =>
        import ("./NewApplication")
})
const AllNewApplication = MatxLoadable({
    loader: () =>
        import ("./AllNewApplication")
})




// const settings = {
//     activeLayout: "layout1",
//     layout1Settings: {
//         topbar: {
//             show: false
//         },
//         leftSidebar: {
//             show: false,
//             mode: "close"
//         }
//     },
//     layout2Settings: {
//         mode: "full",
//         topbar: {
//             show: false
//         },
//         navbar: { show: false }
//     },
//     secondarySidebar: { show: false },
//     footer: { show: false }
// };

const NewApplicationRoutes = [
    {
        path: "/new_application",
        component: AllNewApplication,
        // settings
    },

];

export default NewApplicationRoutes;